var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"modal"},[_c('span',{staticClass:"modal__frase"},[_vm._v(_vm._s(_vm.phrase))])])
}
var staticRenderFns = []

export { render, staticRenderFns }